export default "__VITE_ASSET__Cs3WtcI7__"